module.exports = __webpack_public_path__ + "img/fmovies-alternatives-cover.6533227d.png";